import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../../app.store';
import { type SelectLocationConfiguration } from './selectLocation.state';

const selectLocationIsActiveSelector = (state: AppState) => state.frontendState.mapTools.selectionLocation.active;
export const useSelectLocationIsActiveSelector = () => useSelector(selectLocationIsActiveSelector);

const selectLocationIsLoadingSelector = (state: AppState) => selectLocationIsActiveSelector(state)
  && state.frontendState.mapTools.selectionLocation.isAddressLookupLoading;
export const useSelectLocationIsLoadingSelector = () => useSelector(selectLocationIsLoadingSelector);

export const selectLocationConfigurationSelector = (state: AppState) => selectLocationIsActiveSelector(state)
  && state.frontendState.mapTools.selectionLocation.configuration;
export const useSelectLocationConfigurationSelector = () => useSelector(selectLocationConfigurationSelector);
export const useIsSelectLocationActive = (configuration: SelectLocationConfiguration) =>
  useSelector(state => selectLocationConfigurationSelector(state) === configuration);
